import { Box } from '@mui/material';
import { GroupLightsTile } from 'components/light/GroupLightsTile';
import { LightsTile } from 'components/light/LightsTile';
import { LeafStateProvider } from 'context/state/leaf';
import React from 'react';

import { AppDeviceLeaf, AppGroupLeaf } from 'types/common/leaf';

import styles from './gridView.module.scss';

interface LightGridProps {
  sortedDevices: AppDeviceLeaf[];
  sortedGroups: AppGroupLeaf[];
}

interface DeviceLeavesProps {
  deviceLeaves: Array<AppDeviceLeaf>;
}

const DevicesGrid = ({ deviceLeaves }: DeviceLeavesProps) => (
  <Box className={styles.devicesGrid}>
    {deviceLeaves?.map((device) => (
      <LeafStateProvider key={device.id} leafId={device.id}>
        <LightsTile />
      </LeafStateProvider>
    ))}
  </Box>
);

export const GridView = ({ sortedDevices, sortedGroups }: LightGridProps) => (
  <Box>
    {sortedDevices.length > 0 && <DevicesGrid deviceLeaves={sortedDevices} />}
    {sortedGroups.length > 0 && (
      <Box className={styles.groupGrid}>
        {sortedGroups?.map((group) => {
          const sortedMemberLeaves = Object.values(group.memberLeaves).sort((a, b) => a.name.localeCompare(b.name));
          return (
            <LeafStateProvider key={group.id} leafId={group.id}>
              <GroupLightsTile key={group.id}>
                <DevicesGrid deviceLeaves={sortedMemberLeaves} />
              </GroupLightsTile>
            </LeafStateProvider>
          );
        })}
      </Box>
    )}
  </Box>
);
